import React from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';
import { Typography, Grid } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { constants } from 'helpers/constants';
import type IProduct from 'interfaces/IProduct';
import { CHECKOUT_ELEMENTS_URL } from 'settings';

const { useBreakpoint } = Grid;

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
}

const CheckoutLink = ({ currentProduct, currentUserId, physicalProductPending }: IProps) => {
  const productId = currentProduct.hash ?? currentProduct.id;
  const isAffiliated = currentProduct.producer_id !== currentUserId;
  const urlCustomizeCheckout = `${constants.links.CustomizeCheckout}?productId=${currentProduct.id}`;
  const urlCheckout = `${CHECKOUT_ELEMENTS_URL}/${productId}${isAffiliated ? `?a=${currentUserId}` : ''}`;

  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  if (physicalProductPending) {
    return null;
  }

  return (
    <div className='flex flex-col'>
      <div className='mb-2 flex justify-start'>
        <Typography.Text className='text-[1.25rem] text-black'>Novo Checkout Sun</Typography.Text>
        <div className='flex items-center justify-center max-sm:hidden'>
          <Typography.Text className='ml-2! inline-block rounded-[16px] bg-[#66D26A] px-4! py-0.5! text-center text-xs! font-medium!'>
            Novidade!
          </Typography.Text>
        </div>
      </div>

      <div className='flex items-center'>
        <div className='min-w-76 max-sm:w-full max-sm:min-w-0'>
          <CustomCopyToClipboard fullWidth disableUnderline text={currentProduct ? urlCheckout : ''} />
        </div>

        {!isMobile && (
          <a href={urlCustomizeCheckout} className='ml-5 flex items-center underline' target='_blank' rel='noreferrer'>
            Personalizar Checkout <ArrowRightOutlined style={{ marginLeft: '0.625rem', fontSize: 20 }} />
          </a>
        )}
      </div>
      <Typography.Text className='mt-2 block text-[0.875rem] text-black'>
        O novo Checkout Sun é mais rápido e seguro e tem uma taxa de conversão até 10% superior
      </Typography.Text>
    </div>
  );
};

export default CheckoutLink;
